module.exports = __webpack_public_path__ + "static/media/Sev-Al_Socks.f701ec70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Sev-Al_Socks.jpg
// module id = 628
// module chunks = 0